import React from 'react'
import styled from 'styled-components'
import { AppModal } from '../../../../../generic/ui/Modal'
import MiunPageLayout from '../Components/MiunPageLayout'
import MiunCreateScrollArea from '../Create/Components/MiunCreateScrollArea'
import MiunTitleCard from '../Create/Components/MiunTitleCard'
import MiunActionDock from '../Create/Components/MiunActionDock'
import LineCard from './Components/LineCard'
import MiunLineModal from './Components/MiunLineModal'
import useMiunLines from './services/hooks/useMiunLines'

const MiunLines: React.FC = () => {
    const {
        selectedSortingItem,
        lines,
        packageList,
        qualityList,
        sizeList,
        isOpenModal,
        selectedLine,
        handleOpenCreate,
        handleCloseModal,
        handleOpenEdit,
        saveLine,
        handleBack,
    } = useMiunLines()

    const lastIndex = lines.length - 1
    const isEmpty = lines.length < 1

    return (
        <MiunPageLayout
            title={`שורות מיון #${selectedSortingItem?.Sorting_Num ?? ''}`}
        >
            <MiunCreateScrollArea
                scrollHeader={
                    selectedSortingItem ? (
                        <MiunTitleCard data={selectedSortingItem} />
                    ) : null
                }
            >
                {isEmpty ? (
                    <EmptyState>
                        <img src='/images/no-data.png' alt='empty data' />
                    </EmptyState>
                ) : (
                    lines.map((line, idx) => (
                        <LineCard
                            key={line.id ?? line.SortRow}
                            item={line}
                            isLast={idx === lastIndex}
                            onEdit={handleOpenEdit}
                        />
                    ))
                )}
            </MiunCreateScrollArea>

            <MiunActionDock
                onBack={handleBack}
                onCreate={handleOpenCreate}
                canCreate={!!selectedSortingItem}
                createLabel='הוסף שורה'
            />

            {isOpenModal && (
                <AppModal
                    size='sm'
                    title={selectedLine ? 'עריכת שורה' : 'הוספת שורה'}
                    Children={MiunLineModal}
                    childrenProps={{
                        packageList,
                        qualityList,
                        sizeList,
                        selectedLine,
                        saveLine,
                    }}
                    controlFunc={handleCloseModal}
                />
            )}
        </MiunPageLayout>
    )
}

export default MiunLines

const EmptyState = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`
